import {BaseUserService} from './base-user.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {PageResult} from '../../shared/page-result';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';

export abstract class BaseUserTableService<T, F> extends BaseUserService {

  initData = new BehaviorSubject<T[]>([]);
  lastUserCollection: T;
  count = 0;

  protected constructor(protected http: HttpClient) {
    super();
  }

  public abstract getBaseUrl(): string;

  public canRememberLast(filterDto: F): boolean {
    return false;
  }

  public findList(page = 0, pageSize = 10, sort = 'id', sortOrder = 'asc', token: string,
                  filterDto: F): Observable<PageResult<T>> {
    if (sortOrder === '') {
      sortOrder = 'asc';
      sort = 'id';
    }
    const observable = this.http
      .get<PageResult<T>>(this.getBaseUrl() + `/${sort}/${sortOrder}/${page}/${pageSize}`,
        {headers: this.createHeaders(token), params: this.normalizeToQueryParams(filterDto)});
    if (this.canRememberLast(filterDto)) {
      observable.subscribe(result => {
        this.count = result.totalElements;
        this.initData.next(result.content);
      });
    }
    return observable;
  }

  public find(id: string, token: string) {
    return this.http.get<T>(this.getBaseUrl() + `/${id}`,
      {headers: this.createHeaders(token)});
  }

  public delete(id: string, token: string) {
    return this.http.delete<T>(this.getBaseUrl() + `/${id}`,
      {headers: this.createHeaders(token)});
  }

  public update(userCollection: T, token: string) {
    return this.http.post<number>(this.getBaseUrl(), userCollection,
      {headers: this.createHeaders(token)});
  }

  protected abstract normalizeToQueryParams(filterDto: F): {
    [param: string]: string | string[];
  };

}
